import { createModel } from '@/store/tools';

const model = {
    namespace: 'shippingfeeset',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getShippingFees': T('getShippingFees'),
            'getShippingFeeInfo': T('getShippingFeeInfo'),
            'getComponentShippingFees': T('getComponentShippingFees'),
            'getComponentShippingFeeInfo': T('getComponentShippingFeeInfo'),
            'getControlLog': T('getControlLog'),
        },
        actions: {
            'getShippingFees': A('getShippingFees'),
            'getShippingFeeInfo': A('getShippingFeeInfo'),
            'clearShippingFeeInfo': C('getShippingFeeInfo'),
            'getComponentShippingFees': A('getComponentShippingFees'),
            'getComponentShippingFeeInfo': A('getComponentShippingFeeInfo'),
            'clearCompanyShippingFeeInfo': C('getComponentShippingFeeInfo'),
            'getControlLog': A('getControlLog'),

        },
        sagas: {
            'getShippingFees': S('getShippingFees', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.selectAll'),
            'getShippingFeeInfo': S('getShippingFeeInfo', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.detail'),
            'getComponentShippingFees': S('getComponentShippingFees', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.enterpriseList'),
            'getComponentShippingFeeInfo': S('getComponentShippingFeeInfo', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.enterpriseDetail'),
            'getControlLog': S('getControlLog', '/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.regulateList'),
        },
        reducers: {
            'shippingFees': R('getShippingFees', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'shippingFeeInfo': R('getShippingFeeInfo', { category: [], cityInfo: { city: [], provide: [] }, deliveryFee: { baseFee: [], periodFee: [], weightFee: [] } }),
            'componentShippingFees': R('getComponentShippingFees', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'componentShippingFeeInfo': R('getComponentShippingFeeInfo', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'controlLog': R('getControlLog', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 10 }),
        }
    })
};
export default createModel(model);